import styled from "styled-components";
const InputWithLabel = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
`;
export default InputWithLabel;
